import { render, staticRenderFns } from "./TransferConfigHistories.vue?vue&type=template&id=fb968fe2&"
import script from "./TransferConfigHistories.vue?vue&type=script&lang=js&"
export * from "./TransferConfigHistories.vue?vue&type=script&lang=js&"
import style0 from "./TransferConfigHistories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports